import React from 'react'
import { PasswordStrengthService } from '../../Utils/passwordStrength'

export const PasswordStrengthIndicator = ({ password }) => {
  const strength = PasswordStrengthService.calculateStrength(password)
  
  if (!password) return null

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-gray-600">Password strength:</span>
        <span className={`text-xs font-medium ${PasswordStrengthService.getStrengthTextColor(strength)}`}>
          {PasswordStrengthService.getStrengthText(strength)}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1">
        <div
          className={`h-1 rounded-full transition-all duration-300 ${PasswordStrengthService.getStrengthColor(strength)}`}
          style={{ width: `${(strength / 5) * 100}%` }}
        ></div>
      </div>
    </div>
  )
}